import UpSwitchShop from "../UpSwitchShop";

import { Row } from "./styles";

export interface UpSwitchLanguageShopProps {
  languageSwitch?: boolean;
  shopSwitch?: boolean;
}

const UpSwitchLanguageShop = ({ shopSwitch }: UpSwitchLanguageShopProps) => (
  <Row>{shopSwitch ? <UpSwitchShop disabled={false} /> : null}</Row>
);

export default UpSwitchLanguageShop;
